import OapFocusTrap from './code/Scripts/components/OapFocusTrap.vue';

export default {
  components: {
    OapFocusTrap,
  },
};
